import React from 'react';
import './ContentList.css';
import Content from '../Content';

const ContentList = ({contentData}) => (
  <>
    {contentData.map((content, index) => (
      <Content
        key={index}
        title={content.heading}
        subtitle={content.subheading}
        text={content.text}
        actionText={content.actionText}
        fullAddress={content.fullAddress}
        phone={content.phone}
      />
    ))}
  </>
);

export default ContentList;